module.exports = __webpack_public_path__ + "fonts/adb500eaa7b2e9bae04cb8ee99a0c36d.svg";